import page from './page.json'

const pages = { page };

export default pages;